import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import { Shield, CheckCircle, AlertCircle, Loader2, Mail } from 'lucide-react';
import { API_URL } from '../config';
import '../styles/Auth.css';


const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/auth/verify-email/${token}`);
      setStatus('success');
      
      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      console.error('Email verification failed:', err);
      setError(err.response?.data?.detail || 'Verification failed. The link may be invalid or expired.');
      setStatus('error');
    }
  };

  const renderContent = () => {
    switch (status) {
      case 'verifying':
        return (
          <div className="auth-status-container">
            <Loader2 className="auth-spinner" size={48} />
            <h2>Verifying your email...</h2>
            <p>Please wait a moment.</p>
          </div>
        );
      
      case 'success':
        return (
          <div className="auth-status-container success">
            <CheckCircle size={64} className="success-icon" />
            <h2>Email Verified!</h2>
            <p>Your email has been verified successfully.</p>
            <p className="auth-note">Redirecting to login...</p>
            <div className="auth-actions" style={{ marginTop: '24px' }}>
              <Link to="/login" className="auth-submit-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>
                Go to Login
              </Link>
            </div>
          </div>
        );
      
      case 'error':
        return (
          <div className="auth-status-container error">
            <AlertCircle size={64} className="error-icon" />
            <h2>Verification Failed</h2>
            <p>{error}</p>
            <div className="auth-error-actions">
              <Link to="/resend-verification" className="auth-secondary-btn">
                Request New Verification Link
              </Link>
              <Link to="/login" className="auth-link-btn">
                Go to Login
              </Link>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <div className="auth-page verify-email-page">
        <div className="auth-container">
          <div className="auth-logo-container">
            <Shield size={40} />
            <span>All Secured</span>
          </div>
          
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
